import { render } from "./PostCaptions.vue?vue&type=template&id=503ae9d6&scoped=true"
import script from "./PostCaptions.vue?vue&type=script&lang=js"
export * from "./PostCaptions.vue?vue&type=script&lang=js"

import "./PostCaptions.vue?vue&type=style&index=0&id=503ae9d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503ae9d6"]])

export default __exports__